import React from 'react';
import { styled, css } from "styled-components";

const P = styled.p`
  border-radius: 16px;
  background: #E8FAED;
  mix-blend-mode: multiply;
  padding: 3px 20px;
  padding-left: 26px;
  width: auto;
  color: #00A88A;
  text-align: center;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  
  ${p => p.type == 'warning'
    ? css`
      background: #FCF8E9;
      color: #EA7B30;
    `
    : css``
  }
  
  &::before {
    content: '\\2022';
    font-size: 30px;
    position: absolute;
    margin-left: -13px;
  }
`;

const Message = ({ children, type }) => {
  return <P type={type}>{children}</P>
};

export default Message;
